import axios from 'axios'
import { useState } from 'react'

export const useFormEmail = (initialForm, validateForm, order) => {
  const [form, setForm] = useState(initialForm)
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState(null)

  const handleChange = (event) => {
    const { name, value } = event.target
    setForm({
      ...form,
      [name]: value
    })
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    const err = validateForm(form)
    const orden = order.orden
    const token = orden.token

    if (err === null) {
      setLoading(true)

      const req = {
        email: form.email,
        orden,
        id: order.id
      }

      axios
        .post(process.env.REACT_APP_BACKEND_URL + 'Facturar/Reenviar/', req, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then(function (res) {
          const response = res.data

          setResponse(response)
          setTimeout(() => setResponse(null), 3000)
          setTimeout(() => setLoading(false), 0)
        })
        .catch(function () {
          const res = {
            status: false,
            msg: 'Favor de intentarlo mas tarde'
          }
          setResponse(res)
          setTimeout(() => setResponse(null), 3000)
          setTimeout(() => setLoading(false), 0)
        })
    } else {
      setErrors(validateForm(form))
      setTimeout(() => setErrors({}), 3000)
    }
  }

  return {
    form,
    errors,
    loading,
    response,
    handleChange,
    handleSubmit
  }
}
